module.exports = __webpack_public_path__ + "img/fecha_nacimiento.adbf7e67.svg";